var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.viewType === 'explorer')?_c('DataExplorer',{attrs:{"parameters":_vm.parameters,"computedParameters":_vm.computedParameters,"defaultParameterValues":_vm.parameterValues,"indicators":_vm.indicators,"notes":_vm.notes}}):_c('RegionChart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }